// Create Group
export const CREATE_GROUP_REQUEST = 'CREATE_GROUP_REQUEST';
export const CREATE_GROUP_DONE = 'CREATE_GROUP_DONE';
export const CREATE_GROUP_FAILED = 'CREATE_GROUP_FAILED';
export const CREATE_GROUP_RESET = 'CREATE_GROUP_RESET';